import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-inspraak-inwoners',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconInspraakInwoners {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M4.05 7.78c.56 0 1.01-.44 1.01-.97V.73c0-.4-.34-.73-.76-.73s-.76.33-.76.73v2.19H2.28C1.02 2.92 0 4.14 0 5.35s1.02 2.43 2.27 2.43h1.77Zm12.33 28.21 1.28-5.56 7.57-7.3.06-2.7c0-3.89-4.05-3.89-4.04-3.9H8.54c-2.38 0-3.47-2.83-3.47-4.86v-.97c0-.54-.46-.97-1.02-.97H2.03c-.56 0-1.01.44-1.01.98v.96c0 4.15 2.94 8.76 7.52 8.76h.57v14.6c0 .54.45.97 1.01.97h6.26Zm6.71-1.12-3.56-3.42-.99 3.77c-.09.35.24.68.61.59l3.93-.93Zm12.62-13.58-2.14-2.06a1.04 1.04 0 0 0-1.43 0L21.01 29.96l3.56 3.43 11.14-10.72c.39-.38.39-1 0-1.38M8.92 5.54c.69-3.16 3.56-5.54 7-5.54 2.01 0 3.83.81 5.13 2.12-.02.72-.2 1.25-.54 1.6-.91.94-3.13.88-5.27.83-2.31-.06-4.69-.11-6.31.98Zm13.62-1.18c.34.82.53 1.71.53 2.65 0 3.87-3.21 7-7.16 7-3.19 0-5.9-2.04-6.82-4.87-.14-.74.06-1.2.43-1.61.94-1.04 3.42-1.03 5.65-.97 2.59.06 5.27.13 6.81-1.46.22-.22.4-.48.56-.75Z"/>
</svg>

    );
  }
}
